export type BackgroundConfig = {
  type: 'none' | 'blur' | 'image';
  url?: string | File;
};

export type CustomBackgroundType = Array<File>;

// export const backgroundImageUrls = [
//   'bg1',
// ].map(imageName => `${process.env.PUBLIC_URL}/backgrounds/${imageName}.jpg`);

export const backgroundImageUrls = Array.from(
  { length: 8 },
  (v, i) => `${process.env.PUBLIC_URL}/backgrounds/bg${i + 1}.jpg`,
);
